import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=22ae9053&scoped=true&name=Training&"
import script from "./Training.vue?vue&type=script&lang=js&"
export * from "./Training.vue?vue&type=script&lang=js&"
import style0 from "./Training.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Training.vue?vue&type=style&index=1&id=22ae9053&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae9053",
  null
  
)

export default component.exports